export default {
  auto: '*',
  store: {
    getters: {
      fileType: (_, getters) => ({ type }) =>
        getters.fileTypes[type] ? getters.fileTypes[type] : getters.fileTypes.ETC,

      fileTypes: () => ({
        DOC: { theme: 'info', icon: 'doc' },
        DOCX: { theme: 'info', icon: 'docx' },
        // ETC: { theme: 'neutral', icon: 'etc' },
        // HTML: { theme: 'info', icon: 'html' },
        // MP3: { theme: 'warning', icon: 'mp3' },
        // ODT: { theme: 'info', icon: 'odt' },
        PDF: { theme: 'danger', icon: 'pdf' },
        // PNG: { theme: 'purple', icon: 'png' },
        // PPT: { theme: 'purple', icon: 'ppt' },
        // PPTX: { theme: 'purple', icon: 'ppt' },
        // TXT: { theme: 'info', icon: 'txt' },
        // XLS: { theme: 'success', icon: 'xls' },
        // XLSX: { theme: 'success', icon: 'xls' },
      }),
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/files.js